export enum SortingEnum {
  POPULARITY = 'POPULARITY',
  BEST_DEALS = 'BEST_DEALS',
  PRICE = 'PRICE',
  DISTANCE = 'DISTANCE',
}
